import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

const Option = props => {
  const { innerProps } = props;
  return (
    <components.Option
      {...props}
      innerProps={{
        ...innerProps,
        onClick: e => {
          // Prevents sending multiple events when clicking the label
          e.stopPropagation();
          e.preventDefault();
          innerProps.onClick(e);
        },
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <label
          style={{ display: 'inline-block', paddingLeft: '10px', margin: 0 }}
        >
          <input
            style={{
              verticalAlign: 'middle',
              margin: 0,
            }}
            type="checkbox"
            // eslint-disable-next-line react/prop-types
            checked={props.isSelected}
            onChange={() => null}
          />
          <span
            style={{
              verticalAlign: 'middle',
              paddingLeft: '15px',
              marginTop: '2px',
            }}
          >
            {
              // eslint-disable-next-line react/prop-types
              props.label
            }
          </span>
        </label>
      </div>
    </components.Option>
  );
};

const ValueContainer = props => (
  <components.ValueContainer {...props}>
    <span>
      {
        // eslint-disable-next-line react/prop-types
        props.selectProps.placeholder
      }
    </span>
  </components.ValueContainer>
);

class CheckboxMultiSelect extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.node,
        label: PropTypes.node,
      }),
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    styles: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    options: [],
    placeholder: '',
    styles: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      customStyles: Object.assign(
        {},
        {
          control: base => ({
            ...base,
            boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)',
          }),
          menu: base => ({
            ...base,
            minWidth: 200,
            zIndex: 1000,
          }),
          option: base => ({
            ...base,
            backgroundColor: 'white',
            color: 'black',
            padding: 0,
          }),
        },
        this.props.styles,
      ),
    };
  }

  render() {
    // onFocus and onBlur not working due to:
    // https://github.com/JedWatson/react-select/issues/3595
    return (
      <Select
        {...this.props}
        components={{ Option, ValueContainer }}
        backspaceRemovesValue={false}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isClearable={false}
        isMulti
        isSearchable={false}
        openMenuOnFocus
        openMenuOnClick
        styles={this.state.customStyles}
      />
    );
  }
}

export default CheckboxMultiSelect;
